import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import styled, { css } from 'styled-components';

const InputContainer = styled.div`
  border: 1px solid ${select('midDarkGrayAux')};
  height: 48px;
  border-radius: 8px;
  padding-left: 75px;
  padding-right: 8px;
  position: relative;
  display: flex;
  justify-content: center;
  &:focus-within {
    border: 1px solid ${getColor('primary')};
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 1px solid ${getColor('primary')};
    `}
  ${({ error }) =>
    error &&
    css`
      border: 1px solid ${select('redNoTRecommended')};
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      border: 1px solid ${select('midNeutralGray')};
    `}
`;

const InputStyled = styled.input`
  width: 100%;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${select('midNeutralGray')};
      background-color: white;
    `}
`;

const TypeSelector = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 67px;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  border-radius: 8px 0px 0px 8px;
  border-right: 1px solid ${select('midDarkGrayAux')};
  background-color: ${select('neutralGray')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding-left: 8px;
  ${InputContainer}:focus-within & {
    border-right: 1px solid ${getColor('primary')};
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      border-right: 1px solid ${getColor('primary')};
    `}
  ${({ error }) =>
    error &&
    css`
      border-right: 1px solid ${select('redNoTRecommended')};
    `}
  ${({ disabled }) => {
    return (
      disabled &&
      css`
        color: ${select('midDarkGrayAux')};
        cursor: not-allowed;
        background-color: ${select('neutralGray')};
      `
    );
  }}
  ${({ hasOptions }) => {
    return (
      !hasOptions &&
      css`
        cursor: unset;
        padding-left: 0px;
      `
    );
  }}
`;

const TypeSelectorOpContainer = styled.div`
  background-color: white;
  position: absolute;
  top: 50px;
  left: 0;
  width: 90px;
  border: 1px solid ${select('neutralDarkGray')};
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 8px;
  z-index: 1;
`;

const TypeOption = styled.div`
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  height: 48px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  :hover {
    background-color: ${select('neutralGray')};
  }
  ${({ isSelected }) => {
    return (
      isSelected &&
      css`
        font-weight: 600;
      `
    );
  }}
`;

const MainContainer = styled.div`
  width: ${({ width }) => width};
  ${({ isSecondPrice }) =>
    isSecondPrice &&
    css`
      margin-top: 24px;
    `}
`;

const Label = styled.div`
  margin-bottom: 10px;
`;

const InputError = styled.div`
  color: ${select('redNoTRecommended')};
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: break-spaces;
  margin-top: 4px;
`;

const Img = styled.img`
  height: ${({ height }) => height || '22px'};
  width: ${({ width }) => width || '22px'};
  ${({ isOpen }) => {
    return (
      isOpen &&
      css`
        transform: rotate(180deg);
      `
    );
  }}
`;

export {
  InputContainer,
  InputStyled,
  TypeSelector,
  TypeOption,
  MainContainer,
  Label,
  InputError,
  TypeSelectorOpContainer,
  Img
};
